<div
  class="flex flex-col justify-center items-stretch max-w-full"
  [formGroup]="form"
>
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" [testId]="testIds.NAME_INPUT" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Value Type</mat-label>
    <mat-select
      formControlName="data_type"
      [testId]="testIds.VALUE_TYPE_SELECT"
    >
      <mat-option *ngFor="let type of valueTypes" [value]="type.value">{{
        type.label
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <app-attribute-value-input
    [testId]="testIds.INITIAL_VALUE_INPUT"
    formControlName="starting_value"
    label="Starting Value"
    [type]="form.value.data_type"
  ></app-attribute-value-input>

  <div class="flex flex-row justify-start items-center gap-4">
    <mat-checkbox
      [testId]="testIds.ADD_TO_HIRE_ITEM_NOTES_CB"
      formControlName="append_to_hire_item_notes"
    ></mat-checkbox>
    <p>Add to hire item notes on update</p>
  </div>

  <div class="flex flex-row justify-start items-center gap-4">
    <mat-checkbox
      [testId]="testIds.DISPLAY_ON_PUBLIC_PAGE_CB"
      formControlName="display_on_summary"
    ></mat-checkbox>
    <p>Display on Item Summary</p>
  </div>

  <div class="flex flex-row justify-start items-center gap-4">
    <mat-checkbox
      formControlName="display_on_public_page"
      [testId]="testIds.DISPLAY_ON_PUBLIC_PAGE_CB"
    ></mat-checkbox>
    <p>Display on Public Page</p>
  </div>

  <div class="flex flex-col" formGroupName="prompts">
    <h3>Prompts</h3>
    <p>
      Prompt users when performing the following actions to update the value of
      this attribute
    </p>
    <div class="flex flex-col gap-4">
      <div
        *ngFor="let prompt of prompts"
        class="flex flex-row justify-start items-center gap-4"
        [formGroupName]="prompt.key"
      >
        <mat-label>{{ prompt.name }}:</mat-label>
        <mat-checkbox
          formControlName="enabled"
          [testId]="prompt.key + testIds.PROMPT_ENABLED_SUFFIX"
        ></mat-checkbox>
        <mat-form-field>
          <mat-label>Prompt Type</mat-label>
          <mat-select
            formControlName="type"
            [testId]="prompt.key + testIds.PROMPT_TYPE_SELECT_SUFFIX"
          >
            <mat-option value="inline">Inline</mat-option>
            <mat-option value="popup">Popup</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
